<template>

  <el-drawer v-model="model" :size="anchoSidebar" header-class="py-1 d-flex bg-primary my-0 text-white" destroy-on-close
    direction="ltr" @open="cargarAutor" @closed="limpiarAutor" footer-class="d-flex bg-dark py-1">

    <template #header>
      <h3 class="text-white">Perfil Autor</h3>
    </template>
    <datos-public-autor v-model="autor" />
  </el-drawer>
</template>

<script setup>



import useUtils from '@composables/useUtils';
import usuarioStore from '@/store/usuario';
import DatosPublicAutor from 'views/DatosPublicAutor.vue';

const model = defineModel({
  type: Boolean,
  default: false
});

const props = defineProps({
  slug:{
    type:String,
    required:true
  }
});

const autor = ref({});

const {slug} = toRefs(props);
const usuario_store = usuarioStore();

const {
  anchoSidebar,
  loading,
} = useUtils();

const cargarAutor = () => {
  usuario_store.fetchPublicAutor(slug.value)
  .then(data => {
    if(data.id){
      autor.value = data;
    }
  }).catch(e => {
    console.error('Error al cargar el autor:', e);
  })
}

const limpiarAutor = () => {
  autor.value = {};
}

watch(slug, (newSlug) => cargarAutor());

</script>

<style lang="scss" scoped>
textarea {
  field-sizing: content;
}
</style>